<template>
<div class="newsPage">
	<div class="newsImageBox" ref="headerImageRef">
		<img class="newsImage" src="@/assets/newsIMG.png" />
		<div class="newsTextBox">
			<div class="newsTitle" style="margin-top: 3rem;">
				前沿动态，专业价值<br />
                Cutting-Edge Updates, Professional Value
			</div>
			<div class="newsText" style="margin-top: 3rem;">
				在这里，读懂心理健康领域的趋势与思考<br />
                Here, understand trends and insights in mental wellness
			</div>
		</div>
	</div>

    <div style="height: 11.7rem; width: 1px;" />
    <div class="newsBox">
        <div class="newsMenu">
            <div class="menuTitle">
                类型
            </div>
            <template v-for="item in categoryList">
                <div class="menuSplitter" />
                <div class="menuCategory" @click="filterCategory(item.id)">
                    {{item.name}}({{ item.count }})
                </div>
            </template>
            <div style="height: 5rem; width: 1px;" />
            <div class="menuTitle">
                推荐
            </div>
            <div class="menuSplitter" />
            <template v-for="item in hightlightList">
                <div class="menuHighlight" @click="showNews(item.volume, item.issue)">
                    <div class="highlightTitle" style="width: 14rem">{{item.name}}</div>
                    <div style="flex: 1; height: 1px;" />
                    <div class="highlightTitle" style="width: 6.5rem">{{item.date | formatDate}}</div>
                </div>
            </template>
            <div style="height: 5rem; width: 1px;" />
            <div class="menuTitle">
                标签
            </div>
            <div style="height: 2.5rem; width: 1px;" />
            <div class="tagBox">
                <div class="tagItem" :class="{ 'tagSelected': item.selected }" @click="filterTag(index)" v-for="item, index in tagList">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div style="width: 2rem; height: 1px;" />
        <div class="newsList" v-if="!viewDetail">
            <div class="newsItem" v-for="item, index in pageNewsList" :key="index" @click="showNews(item.volume, item.issue)">
                <img class="newsPic" :src="`/news_pic/v${item.volume}i${item.issue}.png`" />
                <div class="infoLine">
                    <img class="infoIcon" src="@/assets/news0.png" />
                    <div style="width: 0.7rem; height: 1px;" />
                    <div class="infoText">
                        {{ item.author }}
                    </div>
                    <div style="width: 2rem; height: 1px;" />
                    <img class="infoIcon" src="@/assets/news1.png" />
                    <div style="width: 0.7rem; height: 1px;" />
                    <div class="infoText">
                        {{ item.date }}
                    </div>
                </div>
                <div class="titleText">
                    第{{ item.index }}期：{{ item.name }}
                </div>
                <div class="contentText">
                    {{ item.briefing }}
                </div>
                <div class="viewMore">
                    <div class="moreText">
                        查看更多
                    </div>
                    <img class="moreIcon" src="@/assets/arrow_g.png" />
                </div>
            </div>
        </div>
        <newsDetail class="newsDetail" v-else :volume="viewingVolume" :issue="viewingIssue" />
    </div>


</div>
</template>

<script>
import newsDetail from '@/components/news_detail_view.vue';

let allNewsList = [];
async function getMenu() {
  const res = await fetch(`/news/news_menu.json?_=${Date.now()}`, {
    cache: "no-store"
  });
  let output = await res.json();
  allNewsList = output.list;
  return output;
}

export default {
	data() {
		return {
            categoryList: [],
            tagList: [],
            hightlightList: [],
            newsList: [],
            currentPage: 1,
            pageSize: 6,

            viewingVolume: "0",
            viewingIssue: "0",
            viewDetail: false,
        }
    },
    props: {
        routeInfo: {
            type: Object,
            default: () => ({ pagePath: 'news_page', parts: [] })
        }
    },
	methods: {
        // 过滤筛选对应类型的新闻
        filterCategory(categoryId) {
            if (this.viewDetail) this.exitDetailReplace();

            let filteredList = [];
            for (let news of allNewsList) {
                if (news.categoryValue == categoryId) {
                    filteredList.push(news)
                }
            }
            this.newsList = filteredList;
            this.currentPage = 1;

            this.tagList.forEach(item => {
                item.selected = false;
            });
        },
        filterTag(index) {
            if (this.viewDetail) this.exitDetailReplace();

            this.tagList[index].selected = !this.tagList[index].selected;

            const selectedTagIds = this.tagList
                .filter(t => t.selected)
                .map(t => String(t.id));

            if (selectedTagIds.length === 0) {
                this.newsList = allNewsList.slice();
                this.currentPage = 1;
                return;
            }

            this.newsList = allNewsList.filter(news => {
                const newsTags = (news.tagValue || []).map(String);
                return selectedTagIds.some(tagId => newsTags.includes(tagId));
            });

            this.currentPage = 1;
        },

        showNews(volume, issue) {
            this.viewDetail = true;
            this.viewingVolume = volume;
            this.viewingIssue = issue;
            window.location.hash = `news_page/${volume}/${issue}`;
        },
        exitDetailReplace() {
            this.viewingVolume = 0;
            this.viewingIssue = 0;
            window.location.replace(`#news_page`);
        },

		emitHeroHeight() {
			const height = this.$refs.headerImageRef ? this.$refs.headerImageRef.offsetHeight : 20;
			this.$emit("headerImageRefHeight", height);
		}
	},
    filters: {
        formatDate(date) {
            let dateList = date.split(".");
            return `${dateList[0]}-${dateList[1] < 10 ? `0${dateList[1]}` : dateList[1]}-${dateList[2] < 10 ? `0${dateList[2]}` : dateList[2]}`
        },
    },
    computed: {
        pageNewsList() {
            const start = (this.currentPage - 1) * this.pageSize
            const end = start + this.pageSize
            return this.newsList.slice(start, end)
        },

        totalPage() {
            return Math.ceil(this.newsList.length / this.pageSize)
        },

        routeKey() {
            const parts = (this.routeInfo && this.routeInfo.parts) ? this.routeInfo.parts : [];
            return parts.join('/');
        }
    },
	created() {
	},
	mounted() {
		this.emitHeroHeight();
		window.addEventListener("resize", this.emitHeroHeight);

        getMenu().then((res) => {
            this.newsList = res.list;

            const counter = {};
            res.list.forEach(item => {
                counter[item.categoryValue] = (counter[item.categoryValue] || 0) + 1;
            });
            this.categoryList = Object.entries(res.categories).map(([id, name]) => ({
                id,
                name,
                count: counter[id] || 0
            }));

            this.tagList = Object.keys(res.tags).map(key => ({
                id: key,
                name: res.tags[key],
                selected: false,
            }));

            const highlightSet = new Set(res.highlightList);
            this.hightlightList = res.list
                .filter(item => highlightSet.has(item.index))
                .map(item => ({
                    name: item.name,
                    date: item.date,
                    volume: item.volume,
                    issue: item.issue,
                }));
        });
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.emitHeroHeight);
	},
	watch: {
        routeKey: {
            immediate: true,
            handler(key) {
                if (!key) {
                    this.viewDetail = false;
                    return;
                }

                const [volume, issue] = key.split('/');
                if (!volume || !issue) {
                    this.viewDetail = false;
                    return;
                }

                this.viewDetail = true;
            }
        }
	},
    components: {
        newsDetail
    },
}
</script>

<style lang="scss" scoped>
.newsPage {
    display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.newsImageBox {
		width: 100vw;
		height: 51.4rem;
		position: relative;
		background-color: #212121;

		.newsImage {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			object-fit: cover;
		}

		.newsTextBox {
			position: absolute;
			width: 1200px;
			left: calc((100% - 1200px) / 2);
			top: 20%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: center;

			.newsTitle {
				font-size: 5.3rem;
				text-align: left;
				color: #FFFFFF;
			}
			.newsText {
				font-size: 1.5rem;
				line-height: 2.5rem;
				text-align: left;
				color: #FFFFFF;
			}
		}
	}

    .newsBox {
        box-sizing: border-box;
        width: 100rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;

        .newsMenu {
            box-sizing: border-box;
            padding: 3.3rem;
            width: 29.2rem;
            box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);

            .menuTitle {
                width: 100%;
                text-align: left;
                font-size: 1.7rem;
                line-height: 2.2rem;
                color: #333333;
            }
            .menuSplitter {
                width: 100%;
                height: 0.1rem;
                background-color: #A5A5A5;
                opacity: 0.1;
                margin-top: 1.3rem;
                margin-bottom: 1.3rem;
            }
            .menuCategory {
                width: 100%;
                text-align: left;
                font-size: 1.3rem;
                line-height: 2.2rem;
                color: #333333;
                opacity: 0.8;
                cursor: pointer;
            }
            .menuCategory:hover {
                opacity: 0.5;
                transition: color 0.3s ease, opacity 0.3s ease;
            }
            .menuHighlight {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: center;
                align-items: flex-start;
                cursor: pointer;

                .highlightTitle {
                    font-size: 1.2rem;
                    line-height: 1.8rem;
                    color: #333333;
                    text-align: left;
                    word-break: break-all;
                }
            }
            .tagBox {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                column-gap: 1rem;
                row-gap: 1.8rem;

                .tagItem {
                    padding: 0.6rem 0.8rem;
                    border: 0.1rem solid rgba(51, 51, 51, 0.3);
                    background-color: #FFFFFF;
                    color: #333333;
                    font-size: 1.3rem;
                    line-height: 2rem;
                    cursor: pointer;
                }
                .tagSelected {
                    // padding: 0.6rem 2rem;
                    border: 0.1rem solid #78DFA2;
                    background-color: #78DFA2;
                    color: #FFFFFF
                }
                .tagItem:hover {
                    opacity: 0.5;
                    transition: color 0.3s ease, opacity 0.3s ease;
                }
            }
        }
        
        .newsList {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            column-gap: 2rem;
            row-gap: 2.5rem;

            .newsItem {
                width: 33.4rem;
                height: 39.7rem;
                box-shadow: 0px 0.3rem 3.3rem 0px rgba(51, 51, 51, 0.05);
                position: relative;
                cursor: pointer;

                .newsPic {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    width: 100%;
                    height: 15.6rem;
                    object-fit: cover;
                }
                .infoLine {
                    position: absolute;
                    top: 18.1rem;
                    left: 0px;
                    width: calc(100% - 4rem);
                    margin: 0rem 2rem;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-end;

                    .infoIcon {
                        width: 1.7rem;
                        height: 1.7rem;
                        display: inline-block;
                    }
                    .infoText {
                        font-size: 1.2rem;
                        color: #78DFA2;
                    }
                }
                .titleText {
                    position: absolute;
                    top: 21.5rem;
                    left: 0px;
                    width: calc(100% - 4rem);
                    text-align: left;
                    margin: 0rem 2rem;
                    font-size: 1.7rem;
                    line-height: 2.5rem;
                    font-weight: 600;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    word-break: break-all;
                }
                .contentText {
                    position: absolute;
                    top: 27.1rem;
                    left: 0px;
                    width: calc(100% - 4rem);
                    text-align: left;
                    margin: 0rem 2rem;
                    font-size: 1.3rem;
                    line-height: 2.2rem;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    word-break: break-all;
                    opacity: 0.8;
                }
                .viewMore {
                    position: absolute;
                    top: 35.3rem;
                    right: 3.6rem;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;

                    .moreText {
                        font-size: 1.3rem;
                        color: #78DFA2;
                    }
                    .moreIcon {
                        display: inline-block;
                        width: 1.7rem;
                        height: 1.7rem;
                    }
                }
            }
            .newsItem:hover {
                opacity: 0.85;
                transition: color 0.3s ease, opacity 0.3s ease;
            }
        }
        .newsDetail {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            margin-bottom: 3.5rem;
        }
    }
}
</style>